export default class SecurityUtils {
	static validatePassword(str = '') {
		const validateObj = {
			isValid: true,
			message: null,
		};
		if (str.length < 8) {
			validateObj.isValid = false;
			validateObj.message = 'Password must be 8 characters or longer.';
			return validateObj;
		}

		if (!/(?=.*[a-z])/.test(str)) {
			validateObj.isValid = false;
			validateObj.message = 'Password must contain at least 1 lowercase alphabetical character.';
			return validateObj;
		}

		if (!/(?=.*[A-Z])/.test(str)) {
			validateObj.isValid = false;
			validateObj.message = 'Password must contain at least 1 uppercase alphabetical character.';
			return validateObj;
		}

		if (!/(?=.*[0-9])/.test(str)) {
			validateObj.isValid = false;
			validateObj.message = 'Password must contain at least 1 numeric character.';
			return validateObj;
		}

		//if (!/(?=.*[!@#\$%\^&\*\'\(\)+\,\-\/:;<\=>\?".\[\]\\\_`{|}~])/.test(str)) {
		if (!/(?=.*[!@#\$%\^\*\(\)+\,\-\/:;=\?.\[\]\\\_`{|}~])/.test(str)) {
			validateObj.isValid = false;
			validateObj.message = 'Password must contain at least 1 special character.';
			return validateObj;
		}

		if (isCharactorsNotAllow(str)) {
			validateObj.isValid = false;
			validateObj.message = "Invalid password, It's not allow some special character.";
			return validateObj;
		}
		return validateObj;
	}

	static uuidv4() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = (Math.random() * 16) | 0,
				v = c === 'x' ? r : (r & 0x3) | 0x8;
			return v.toString(16);
		});
	}
}

function isCharactorsNotAllow(str) {
	return /[^a-zA-Z0-9!@#\$%\^&\*\'\(\)+\,\-\/:;<\=>\?".\[\]\\\_`{|}~]/.test(str);
}
